/**
 * Safari「すべてのCookieをブロック」環境では localStorage / sessionStorage へのアクセスで
 * ReferenceError または SecurityError がスローされる。
 * 安全なラッパーを提供し、利用不可の環境ではストレージ操作を静かにスキップする。
 *
 * @see https://qiita.com/narikei/items/f55fb9cb398beac52ea9
 * @see https://developer.mozilla.org/ja/docs/Web/API/Window/localStorage
 */

const createSafeStorage = (getStorage: () => Storage) => ({
    getItem(key: string): string | null {
        try {
            return getStorage().getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        try {
            getStorage().setItem(key, value);
        } catch {
            // ストレージ利用不可
        }
    },
    removeItem(key: string): void {
        try {
            getStorage().removeItem(key);
        } catch {
            // ストレージ利用不可
        }
    },
});

export const safeLocalStorage = createSafeStorage(() => localStorage);
export const safeSessionStorage = createSafeStorage(() => sessionStorage);
